import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetchDatav2 from "./useFetchDatav2";

// Minimal recent-activity dropdown for the header search. On open it POSTs to
// /getLastViewed.sz and lists the user's recently viewed items. Styling/layout
// (centering, expand animation, "Full search" footer) is a later pass.
export default function RecentsPanel({ open, onClose }) {
   const { fetchData } = useFetchDatav2();
   const [items, setItems] = useState([]);
   const [loading, setLoading] = useState(false);
   const navigate = useNavigate();

   useEffect(() => {
      if (!open) return;
      let cancelled = false;
      (async () => {
         setLoading(true);
         const { responseData } = await fetchData("/getLastViewed.sz", "POST", new FormData(), "form-data");
         if (!cancelled) {
            setItems(responseData?.st === 1 ? responseData.payload || [] : []);
            setLoading(false);
         }
      })();
      return () => {
         cancelled = true;
      };
   }, [open]);

   if (!open) return null;

   const handleClick = (it) => {
      if (it.uv_object_type === "invoice_statement") {
         navigate("/apps/reconcile", {
            state: {
               selectedInvoiceStatement: it.uv_object_id,
               selectedInvoiceStatementSupplierName: it.uv_object_label,
            },
         });
      }
      onClose?.();
   };

   return (
      <div className="search-panel">
         <div className="search-panel-section">Recent</div>
         {loading && <div className="search-panel-loading">Loading…</div>}
         {!loading && items.length === 0 && (
            <div className="search-panel-empty">
               Nothing viewed yet — statements and suppliers you open will show up here.
            </div>
         )}
         {items.map((it) => (
            <button
               key={`${it.uv_object_type}:${it.uv_object_id}`}
               className="search-panel-item"
               onMouseDown={() => handleClick(it)} // mousedown fires before the input blur closes the panel
            >
               <span className="search-panel-icon">
                  <i className={it.vot_icon || "ri-file-list-3-line"}></i>
               </span>
               <span className="search-panel-label">{it.uv_object_label || it.uv_object_id}</span>
               <span className="search-panel-type">{it.vot_label}</span>
            </button>
         ))}
      </div>
   );
}
